import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import TokenTerms from "../../../components/shared/token-terms";
import { Helmet } from "react-helmet-async";

const TokenTermsCondition = () => {
    return (
        <React.Fragment>
            <Helmet>
                <meta name="ROBOTS" content="NOINDEX,FOLLOW" />
                <title>Cars24 | Token Terms & Conditions</title>
            </Helmet>
            <TokenTerms/>
        </React.Fragment>
    );
};

export default withLayout(TokenTermsCondition);
